import { render, staticRenderFns } from "./BasicTitleCardFullImage.vue?vue&type=template&id=cf2c398c"
import script from "./BasicTitleCardFullImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasicTitleCardFullImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BasicTitleCardFullImage.vue?vue&type=style&index=0&id=cf2c398c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports